import * as React from "react";
import styled, { css } from "../../../styled/index";
const stopPropagation = (e) => e.stopPropagation();
const SwitchWrapper = styled("div") `
  position: relative;
  label {
    font-weight: 400;
    cursor: pointer;
    display: inline-block;
  }
`;
const SwitchInput = styled("input") `
  visibility: visible;
  position: absolute;
  opacity: 0;
  margin-left: -9999px;
  visibility: hidden;
`;
const SwitchLabel = styled("label") `
    display: block;
    position: relative;
    cursor: pointer;
    outline: none;
    user-select: none;
    margin: 0;
    padding: 2px;
    width: 50px;
    height: 24px;
    border-radius: 30px;
    background-color: #dddddd;
    transition: background 0.4s;
    &:before, &:after {
      display: block;
      position: absolute;
      content: "";
    }
    &:before {
      top: 2px;
      left: 2px;
      bottom: 2px;
      right: 2px;
      background: ${({ theme }) => theme.input.background};
      border-radius: 30px;
      transition: background 0.4s;
    }
    &:after {
      top: 4px;
      left: 4px;
      bottom: 4px;
      background-color: #dddddd;
      border-radius: 30px;
      transition: margin 0.4s, background 0.4s;
      width: 16px;
    }
    ${(props) => props.checked ? css `
      background: ${props.theme.colors.primary};
      &:after {
        margin-left: 26px;
        background-color: ${props.theme.colors.primary};
      }
    ` : ""}
`;
export const Switch = (props) => (React.createElement(SwitchWrapper, Object.assign({ onClick: stopPropagation }, props.wrapperProps),
    React.createElement(SwitchInput, Object.assign({ type: "checkbox", id: props.id, name: props.name, onChange: props.onChange, checked: props.checked }, props.inputProps)),
    React.createElement(SwitchLabel, Object.assign({ htmlFor: props.id, checked: props.checked }, props.labelProps))));
//# sourceMappingURL=Switch.js.map